import React, { useState } from "react";
import { useSelector } from "react-redux";
import { FormDiv } from "../common/Helpers";
import Crayon from "../iconComponents/Crayon";
import IconTick from "../iconComponents/IconTick";
import IconX from "../iconComponents/IconX";
import Addfiles from "../common/Addfiles";

export default function Company(props) {

    const userIsCompanyAdmin = useSelector(state => state.auth.user.croles["Company Admin"]);
    const company = useSelector(state => state.company.company);

    const isEditting = props.mode === "company-edit" && userIsCompanyAdmin;
    const [crayonHovered, setCrayonHovered] = useState(false);

    const handleClickCrayon = (e) => {
        props.switchMode();
        setCrayonHovered(false);
    }

    return (
        <div className="gap-below-s settings" >
            <FormDiv formCondition={isEditting} onSubmit={props.handleSubmit}>
                <div className={"subhead-wrapper flex-row" + (isEditting ? " space-btwn" : "")}  >
                    <div>
                        <img className="settings-logo iblock gap-right-xs" src={company.company_icon_path} />
                        <h2 className="title2 heavy iblock gap-right-xs">{company.name}</h2>
                    </div>
                    {isEditting
                        ? <div style={{ marginTop: "-2px", marginBottom: "-2px", marginRight: "-14px" }}>
                            <button className="btn ter mini iblock gap-right-xs" disabled={props.isSubmitting} onClick={() => props.handleCancel()} >Cancel</button>
                            <button type="submit" className="btn pri iblock mini" disabled={props.isSubmitting}>{props.isSubmitting ? "Please wait..." : "Save changes"}</button>
                        </div>
                        : (userIsCompanyAdmin
                            ? <button
                                onClick={(e) => handleClickCrayon(e)}
                                onMouseEnter={() => setCrayonHovered(true)}
                                onMouseLeave={() => setCrayonHovered(false)}
                            >
                                <Crayon className="iblock" height="13px" pathClass={crayonHovered ? "g1-fill" : "g6-fill"} />
                            </button>
                            : <></>
                        )
                    }
                </div>
                <div className="table-wrapper" >
                    <div className="grid">
                        <div className="grid-child" >
                            <h3 className="content2 heavy-grey gap-below-xxs">About</h3>
                            {isEditting
                                ? <>
                                    <div className="inputs-wrapper">
                                        <div className="input-basic">
                                            <input
                                                type="text"
                                                name="name"
                                                id="name"
                                                value={props.newCompanyInfo.name}
                                                onChange={(e) => props.handleChange(e)}
                                                required
                                            />
                                            <label htmlFor="name">Company Name<span> *</span></label>
                                        </div>
                                        {/* <div className="input-basic">										
                                        <input
                                            type="text"
                                            name="industry"
                                            id="industry"	
                                            value={props.newCompanyInfo.industry ? props.newCompanyInfo.industry : ""}
                                            onChange={(e) => props.handleChange(e)}
                                            required
                                        />
                                        <label htmlFor="industry">Industry<span> *</span></label>
                                    </div> */}
                                        <div className="input-basic">
                                            <input
                                                type="text"
                                                name="website_address"
                                                id="website_address"
                                                value={props.newCompanyInfo.website_address ? props.newCompanyInfo.website_address : ""}
                                                onChange={(e) => props.handleChange(e)}
                                            />
                                            <label htmlFor="website_address">Website<span> *</span></label>
                                        </div>
                                        <div className="input-basic">
                                            <input
                                                type="text"
                                                name="phone_number"
                                                id="phone_number"
                                                value={props.newCompanyInfo.phone_number ? props.newCompanyInfo.phone_number : ""}
                                                onChange={(e) => props.handleChange(e)}
                                                required
                                            />
                                            <label htmlFor="phone_number">Phone Number<span> *</span></label>
                                        </div>
                                    </div>
                                    <Addfiles
                                        uploadTitle={company.company_icon_path ? "+ Change Logo" : "+ Add Logo"}
                                        attachments={undefined}
                                        selectedFiles={props.selectedFiles}
                                        handleDrop={props.handleDrop}
                                        removeSelectedFile={props.removeSelectedFile}
                                        removeUploadedFile={undefined}
                                        removedFiles={undefined}
                                        maxSize={10485760}
                                        maxFiles={1}
                                        multiple={false}
                                        accept="image/jpeg, image/png, image/jpg, image/tiff"
                                    />
                                </>
                                : <>
                                    <h4 className="content1 multiline light-black">{company.industry}</h4>
                                    <h4 className="content1 multiline light-black">{company.website_address}</h4>
                                    <h4 className="content1 multiline light-black">{company.phone_number}</h4>
                                </>
                            }
                        </div>
                        <div className="grid-child" >
                            <h3 className="content2 heavy-grey gap-below-xxs"> Address</h3>
                            {isEditting
                                ? <div className="inputs-wrapper">
                                    <div className="input-basic">
                                        <input
                                            type="text"
                                            name="street"
                                            id="street"
                                            value={props.newCompanyInfo.street ? props.newCompanyInfo.street : ""}
                                            onChange={(e) => props.handleChange(e)}
                                        />
                                        <label htmlFor="street">Street Address</label>
                                    </div>
                                    <div className="input-basic">
                                        <input
                                            type="text"
                                            name="city"
                                            id="city"
                                            value={props.newCompanyInfo.city ? props.newCompanyInfo.city : ""}
                                            onChange={(e) => props.handleChange(e)}
                                            required
                                        />
                                        <label htmlFor="city">City<span> *</span></label>
                                    </div>
                                    <div className="input-basic">
                                        <input
                                            type="text"
                                            name="country"
                                            id="country"
                                            value={props.newCompanyInfo.country ? props.newCompanyInfo.country : ""}
                                            onChange={(e) => props.handleChange(e)}
                                            required
                                        />
                                        <label htmlFor="country">Country<span> *</span></label>
                                    </div>
                                    <div className="input-basic">
                                        <input
                                            type="text"
                                            name="postal"
                                            id="postal"
                                            value={props.newCompanyInfo.postal ? props.newCompanyInfo.postal : ""}
                                            onChange={(e) => props.handleChange(e)}
                                        />
                                        <label htmlFor="postal">Zip / Postal Code</label>
                                    </div>
                                </div>
                                : <>
                                    <h4 className="content1 multiline light-black">{company.street}</h4>
                                    <h4 className="content1 multiline light-black">{company.city && company.city + ", "}{company.state && company.state}</h4>
                                    <h4 className="content1 multiline light-black">{company.country}{company.postal && " " + company.postal}</h4>
                                </>
                            }
                        </div>
                        <div className="grid-child" >
                            <h3 className="content2 heavy-grey gap-below-xxs" >Company Admins</h3>
                            {company.company_admins && company.company_admins.map((admin) => {
                                return <h4 className="content1 multiline light-black" key={admin.email} >{admin.first_name + " " + admin.last_name}</h4>
                            })}
                        </div>
                        <div className="grid-child" >
                            <h3 className="content2 heavy-grey gap-below-xxs" >Access</h3>
                            {isEditting
                                ?
                                <>
                                    <div className="checkbox-wrapper" >
                                        <input
                                            className="typical-checkbox"
                                            type="checkbox"
                                            id="is_searchable"
                                            name="is_searchable"
                                            checked={props.newCompanyInfo.is_searchable ? props.newCompanyInfo.is_searchable : false}
                                            onChange={(e) => props.handleToggle(e)}
                                            style={{ marginTop: "4px" }}
                                        />
                                        <label htmlFor="is_searchable" className="content1 light-black multiline" >Searchable</label>
                                    </div>
                                    {(company.domain && company.domain !== "") &&
                                        <div className="checkbox-wrapper" >
                                            <input
                                                className="typical-checkbox"
                                                type="checkbox"
                                                id="has_domain"
                                                name="has_domain"
                                                checked={props.newCompanyInfo.has_domain ? props.newCompanyInfo.has_domain : false}
                                                onChange={(e) => props.handleToggle(e)}
                                                style={{ marginTop: "4px" }}
                                            />
                                            <label htmlFor="has_domain" className="content1 light-black multiline" >Autoverify <span className="heavy">@{props.newCompanyInfo.domain}</span></label>
                                        </div>
                                    }
                                </>
                                : <>
                                    {company.is_searchable
                                        ? <div>
                                            <IconTick height="12px" className="iblock gap-right-xs" pathClass="g1-fill" />
                                            <h4 className="content1 multiline light-black iblock">Searchable</h4>
                                        </div>
                                        : <div>
                                            <IconX height="12px" className="iblock gap-right-xs" pathClass="g7-fill" />
                                            <h4 className="content1 multiline light iblock">Searchable</h4>
                                        </div>
                                    }
                                    {(company.domain && company.domain !== "")
                                        ? (company.has_domain
                                            ? <div>
                                                <IconTick height="12px" className="iblock gap-right-xs" pathClass="g1-fill" />
                                                <h4 className="content1 multiline light-black iblock">Autoverify <span className="heavy">@{company.domain}</span></h4>
                                            </div>
                                            : <div>
                                                <IconX height="12px" className="iblock gap-right-xs" pathClass="g7-fill" />
                                                <h4 className="content1 multiline light iblock">Autoverify <span className="heavy-grey">@{company.domain}</span></h4>
                                            </div>
                                        )
                                        : <></>
                                    }
                                </>
                            }
                        </div>
                    </div>
                </div>
            </FormDiv>
        </div>
    )
}